module.exports = __webpack_public_path__ + "img/404.169358d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/404.png
// module id = 573
// module chunks = 1